export default function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isTransformer.js
// module id = ZJe7
// module chunks = 22